import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default ({ palette, typography, breakpoints }: Theme) =>
  createStyles({
    root: {
      fontFamily: 'Roboto',
      minWidth: '75px !important',
      padding: '6px !important',
      fontSize: '12px !important',
      fontWeight: typography.fontWeightMedium,
      borderRadius: 4,
      margin: '0 8px',

      '&.MuiButton-sizeLarge': {
        height: 45,
        width: 340,

        [breakpoints.down('xs')]: {
          width: 300,
        },
      },

      '&.MuiButton-textSecondary': {
        backgroundColor: palette.secondary.main,
        color: palette.secondary.contrastText,

        '&:hover': {
          backgroundColor: palette.secondary.dark,
        },
      },

      '&:disabled': {
        backgroundColor: palette.grey[200],
        borderColor: palette.grey[200],
        color: palette.grey[500],

        '& .MuiButton-label': {
          color: palette.grey[500],
        },
      },

      '& .MuiButton-label': { fontSize: 12 },
    },

    red: {
      border: `1px solid ${palette.error.light}`,
      background: palette.error.main,
      color: palette.error.contrastText,
      padding: '8px 16px',
      fontSize: 12,

      '&:hover': {
        backgroundColor: palette.error.dark,
      },
    },

    green: {
      border: `1px solid ${palette.success.main}`,
      backgroundColor: '#36996A',
      color: palette.common.white,

      '&:hover': {
        backgroundColor: '#36996A',
      },
    },
    blue: {
      border: `1px solid ${palette.secondary.main}`,
      backgroundColor: palette.secondary.main,
      color: palette.common.white,

      '&:hover': {
        backgroundColor: palette.secondary.main,
        color: palette.common.white,
        opacity: 0.8,
      },
    },
    pressed: { backgroundColor: '#D9D9D9' },
    outlineBlue: {
      border: `1px solid ${palette.secondary.main}`,
      color: palette.secondary.main,
    },
  });
